import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Updates from './components/Updates';
import Cards from './components/Cards';
import Comments from './components/Comments';
import Index from './components/Index';
import Carousel from './components/Carousel';
import Ranking from './components/Ranking';
import Faq from './components/Faq';
import AppSection from './components/AppSection';
import Contact from './components/Contact';
import About from './components/About';
import Media from './components/Media';
import Topics from './components/Topics';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Features />
        <Updates />
        <Cards />
        <Comments />
        <Index />
        <Carousel />
        <Ranking />
        <Faq />
        <AppSection />
        <Contact />
        <About />
        <Media />
        <Topics />
      </main>
      <Footer />
    </div>
  );
}